import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import throttle from 'lodash.throttle';

import { accessRequest } from '../store/data/data.actions';

/**
 *
 * @param hashId
 */
export default (hashId: string): void => {
  const dispatch = useDispatch();
  const [accessed, setAccessed] = useState(false);
  const handler = useCallback(() => {
    if (!accessed) {
      setAccessed(true);
      dispatch(accessRequest({ hashId }));
    }
  }, [dispatch, hashId, accessed]);

  const throttledHandler = throttle(handler, 1000);

  useEffect(() => {
    window.addEventListener('mousemove', throttledHandler);

    return () => {
      window.removeEventListener('mousemove', throttledHandler);
    };
  }, [throttledHandler]);
};
